module.exports = __webpack_public_path__ + "static/media/md-disc.2ed012e4.svg";